module.exports = __webpack_public_path__ + "img/index16.fda6c290.png";